module.exports = __webpack_public_path__ + "img/MES11Indice3.5290e3d2.png";